import { Box, Typography } from '@mui/material';
import Dashboard from '../../components/Dashboard';

// Add this import
import { Outlet } from 'react-router-dom';

function Home() {
  return (
    
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Dashboard/>
      <Outlet />
    </Box>
  );
}

export default Home;
